export enum DateRangeValueType {
  Today = 'today',
  Yesterday = 'yesterday',
  Tomorrow = 'tomorrow',
  ThisWeek = 'this_week',
  LastWeek = 'last_week',
  NextWeek = 'next_week',
  ThisMonth = 'this_month',
  NextMonth = 'next_month',
  LastMonth = 'last_month',
  ThisQuarter = 'this_quarter',
  NextQuarter = 'next_quarter',
  LastQuarter = 'last_quarter',
  ThisYear = 'this_year',
  LastYear = 'last_year',
  NextYear = 'next_year',
  Last7Days = 'last_7_days',
  Last14Days = 'last_14_days',
  Last20Days = 'last_20_days',
  Last30Days = 'last_30_days',
  Last60Days = 'last_60_days',
  Last90Days = 'last_90_days',
  Last365Days = 'last_365_days',
  Custom = 'custom',
  AllTime = 'all_time',
  Exact = 'exact',
  Range = 'range',
  WithinNext = 'within_next',
  WithinLast = 'within_last',
}

export type TDateRangeValueType = `${DateRangeValueType}`;
